export default require('./Divider').default
